module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 11
// module chunks = 0